import EquipmentDto from './EquipmentDto'

export default class EquipmentAssignatedDto extends EquipmentDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
